//TODO: Make this a configuration option
const host = 'https://microsites-fs1.appspot.com/api/v1/';

export const RPCBackend = host + 'block-rpc';
export const BlockBackend = host + 'block';
